module.exports = __webpack_public_path__ + "img/violet_101.49dc4f18.png";